import { MessageBar, MessageBarBody, MessageBarTitle } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

const DetailsError = () => {
    const { t } = useTranslation();

    return (
        <MessageBar intent="error">
            <MessageBarBody>
                <MessageBarTitle>{t("general.error")}</MessageBarTitle>
                {t("devices.errors.loadDevice")}
            </MessageBarBody>
        </MessageBar>
    );
};

const LAPSError = () => {
    const { t } = useTranslation();

    return (
        <MessageBar intent="error">
            <MessageBarBody>
                <MessageBarTitle>{t("general.error")}</MessageBarTitle>
                {t("devices.errors.laps")}
            </MessageBarBody>
        </MessageBar>
    );
};

export { DetailsError, LAPSError };